import type { ActivityOutcome, AutomationStatus, ScheduledActionState } from '@/api/automation'
import { Badge, type BadgeTone } from '@/design'

const AUTOMATION_STATUS: Record<AutomationStatus, { tone: BadgeTone; label: string }> = {
  running: { tone: 'positive', label: 'Running' },
  paused: { tone: 'warning', label: 'Paused' },
  draft: { tone: 'neutral', label: 'Draft' },
}

export function AutomationStatusBadge({ status }: { status: AutomationStatus }) {
  const { tone, label } = AUTOMATION_STATUS[status]
  return <Badge tone={tone}>{label}</Badge>
}

const SCHEDULED_STATE: Record<ScheduledActionState, { tone: BadgeTone; label: string }> = {
  pending: { tone: 'accent', label: 'Pending' },
  completed: { tone: 'positive', label: 'Completed' },
  cancelled: { tone: 'neutral', label: 'Cancelled' },
  failed: { tone: 'negative', label: 'Failed' },
}

export function ScheduledStateBadge({ state }: { state: ScheduledActionState }) {
  const { tone, label } = SCHEDULED_STATE[state]
  return <Badge tone={tone}>{label}</Badge>
}

const ACTIVITY_OUTCOME: Record<ActivityOutcome, { tone: BadgeTone; label: string }> = {
  success: { tone: 'positive', label: 'Success' },
  failure: { tone: 'negative', label: 'Failure' },
  skipped: { tone: 'neutral', label: 'Skipped' },
}

export function ActivityOutcomeBadge({ outcome }: { outcome: ActivityOutcome }) {
  const { tone, label } = ACTIVITY_OUTCOME[outcome]
  return <Badge tone={tone}>{label}</Badge>
}
